import cn from 'classnames';

import styles from '../styles/desktop.css';
import type { IContext } from '../context';

type TArgs = {
    iconPosition: IContext['iconPosition'];
    isOpen?: boolean;
    newDesign: IContext['newDesign'];
};
export const headerClassNamesHelperDesktop = ({ iconPosition, isOpen, newDesign }: TArgs) =>
    cn(
        newDesign ? styles.newHeader : styles.header,
        { [styles.open]: isOpen && newDesign },
        styles[iconPosition]
    );
